import PresentationVideo from "../components/PresentationVideo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PublicPresentationPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "linear-gradient(135deg, #0c1c2e 0%, #0c4a6e 50%, #0c1c2e 100%)" }} data-testid="public-presentation">
      <div className="p-4 flex items-center gap-3">
        <Link to="/login" className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white/70 hover:text-white hover:bg-white/10 transition" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Connexion
        </Link>
        <div className="flex-1" />
        <span className="text-xs text-white/40">CMES Pharma Intel — Presentation</span>
      </div>
      <div className="flex-1">
        <PresentationVideo autoPlay={true} showDownload={false} inline={true} />
      </div>
    </div>
  );
}
